import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { useNavigate } from 'react-router-dom';
import Pagination from '../components/Pagination';
import { findIndexById, findPageNumber, deleteItem, SortIcon, searchArray } from '../components/Navigation';
import { Loader } from '../components/ModalsCommonFunctions';

const CompetitiveExamLessonMaster = () => {
    const authorizedAxios = generateAxiosInstance()

    const initialFormState = {
        competitiveExamNameMasterId: '',
        competitiveExamBookMasterId: '',
        subjectMasterId: '',
        competitiveLessonName: ['']
    }
    const [syllabusList, setSyllabusList] = useState([])
    const [subjectList, setSubjectList] = useState([])
    const [bookList, setBookList] = useState([]);

    const [lessonData, setLessonData] = useState(initialFormState)
    const [lessonList, setLessonList] = useState([])
    const [editId, setEditId] = useState(null)

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);
    const [refresh, setRefresh] = useState(true);
    const [addNew, setAddNew] = useState(false);

    const [examNameSort, setExamNameSort] = useState(null);
    const [bookNameSort, setBookNameSort] = useState(null);
    const [subjectNameSort, setSubjectNameSort] = useState(null);
    const [lessonNameSort, setLessonNameSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["competitiveExamNameMasterDetails.examName", "competitiveExamBookMasterDetails.bookName", "subjectMasterDetails.subjectName", "competitiveLessonName"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            setRefresh(!refresh);
        }
    }, [searchValue]);


    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (lessonData.competitiveExamNameMasterId !== '' && lessonData.competitiveExamBookMasterId !== '' && lessonData.subjectMasterId !== '') {
                let apiUrl = '/get-competitive-lesson?';

                if (lessonData.competitiveExamNameMasterId) {
                    apiUrl += `competitiveExamNameMasterId=${lessonData.competitiveExamNameMasterId}&`;
                }

                if (lessonData.subjectMasterId) {
                    apiUrl += `subjectMasterId=${lessonData.subjectMasterId}&`;
                }

                if (lessonData.competitiveExamBookMasterId) {
                    apiUrl += `competitiveExamBookMasterId=${lessonData.competitiveExamBookMasterId}&`;
                }

                apiUrl = apiUrl.replace(/&$/, '');
                setLessonList(await searchArray("A", apiUrl, searchKeys, searchValue.trim()))
            }
        }
    }

    useEffect(() => {
        // Construct the API URL when lessonData changes
        if (lessonData.competitiveExamNameMasterId !== '' && lessonData.competitiveExamBookMasterId !== '' && lessonData.subjectMasterId !== '') {
            let apiUrl = '/get-competitive-lesson?';

            if (lessonData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${lessonData.competitiveExamNameMasterId}&`;
            }

            if (lessonData.subjectMasterId) {
                apiUrl += `subjectMasterId=${lessonData.subjectMasterId}&`;
            }

            if (lessonData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${lessonData.competitiveExamBookMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            // Make the API call
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result);
                    console.log('Data:', response.data);
                })
                .catch(error => {
                    // Handle any errors that occurred during the request
                    setLessonList(error?.response?.data.result);
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';

                    console.error('Error fetching data:', error);
                });
        }
    }, [lessonData, refresh]);

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(lessonList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId, addNew])

    useEffect(() => {
        setTotalPages(Math.ceil(lessonList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > lessonList.length) {
            endIndex = lessonList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(lessonList.slice(startIndex, endIndex));
    }, [lessonList, currPage, itemsPerPage]);

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-competitive-exam-names`;
        authorizedAxios && authorizedAxios.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getLessonList = () => {
        if (lessonData.competitiveExamNameMasterId !== '' && lessonData.competitiveExamBookMasterId !== '' && lessonData.subjectMasterId !== '') {
            let apiUrl = '/get-competitive-lesson?';

            if (lessonData.competitiveExamNameMasterId) {
                apiUrl += `competitiveExamNameMasterId=${lessonData.competitiveExamNameMasterId}&`;
            }

            if (lessonData.subjectMasterId) {
                apiUrl += `subjectMasterId=${lessonData.subjectMasterId}&`;
            }

            if (lessonData.competitiveExamBookMasterId) {
                apiUrl += `competitiveExamBookMasterId=${lessonData.competitiveExamBookMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            // const apiUrl = `/get-competitive-lesson`;
            authorizedAxios && authorizedAxios.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result)
                    setAddNew(!addNew)
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    }

    const handleSyllabusChange = (e) => {
        setLessonData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                competitiveExamBookMasterId: '',
                subjectMasterId: '',
                competitiveLessonName: ['']
            }
        })

        const apiUrl = `/get-competitive-exam-book-master?competitiveExamNameMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setBookList(response.data.data)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleBookChange = (e) => {
        setLessonData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value,
                subjectMasterId: ''
            }
        });

        const apiUrl = `/get-competitive-exam-book-wise-subject?competitiveExamBookMasterId=${e.target.value}`;
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setSubjectList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', error);
            });
    }

    const handleInputChange = (e, index) => {
        setLessonData((prevData) => {
            if (e.target.name === 'competitiveLessonName') {
                const updatedLessonName = [...prevData.competitiveLessonName];
                updatedLessonName[index] = e.target.value;
                return {
                    ...prevData,
                    competitiveLessonName: updatedLessonName,
                };
            } else {
                return {
                    ...prevData,
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleAddLesson = () => {
        setLessonData((prevData) => ({
            ...prevData,
            competitiveLessonName: [...prevData.competitiveLessonName, ''],
        }));
    };

    const handleRemoveLesson = (index) => {
        setLessonData((prevData) => {
            const updatedLessonName = [...prevData.competitiveLessonName];
            // Remove the element at the specified index
            updatedLessonName.splice(index, 1);
            return {
                ...prevData,
                competitiveLessonName: updatedLessonName,
            }
        });
    };


    //error

    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(lessonData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(lessonData)) {
                if (value == '' || value.length == 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [lessonData])

    const addLesson = () => {
        const apiUrl = `/add-competitive-lesson`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, lessonData)
                .then(response => {
                    getLessonList();
                    setLessonData((prevData) => {
                        return {
                            ...prevData,
                            competitiveLessonName: [''],
                        };
                    })
                    setSaveId(response.data.result[0].id);
                    setExamNameSort(null);
                    setBookNameSort(null);
                    setSubjectNameSort(null);
                    setLessonNameSort(null);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(lessonData)) {
                if (value == '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    const deleteLesson = (id) => {
        let confirmed = window.confirm('Are you sure? you want to delete this record.');
        if (confirmed) {
            setLoading(true);
            const apiUrl = `/delete-competitive-lesson?id=${id}`;
            authorizedAxios && authorizedAxios.delete(apiUrl)
                .then(response => {
                    const page = deleteItem(currPage, itemsPerPage, lessonList.length);
                    setRefresh(!refresh);
                    setCurrPage(page);

                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        }
    }

    const updateLesson = () => {
        setLoading(true);
        const apiUrl = `/edit-competitive-lesson?id=${editId}`;
        authorizedAxios && authorizedAxios.put(apiUrl, { competitiveLessonName: lessonData?.competitiveLessonName[0] })
            .then(response => {
                getLessonList();
                setSaveId(response.data.result.id);
                setEditId(null);
                setLessonData((prevData) => {
                    return {
                        ...prevData,
                        competitiveLessonName: [''],
                    };
                })

                Swal.fire(
                    { text: response.data.message }
                );
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                Swal.fire(
                    { text: errorMsg }
                );
            })
            .finally(() => {
                setLoading(false); // End loading
            });
    }

    useEffect(() => {
        if (examNameSort == true || examNameSort == false) {
            setBookNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [examNameSort])

    useEffect(() => {
        if (bookNameSort == true || bookNameSort == false) {
            setExamNameSort(null);
            setSubjectNameSort(null);
            setLessonNameSort(null);
        }
    }, [bookNameSort])

    useEffect(() => {
        if (subjectNameSort == true || subjectNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setLessonNameSort(null);
        }
    }, [subjectNameSort])

    useEffect(() => {
        if (lessonNameSort == true || lessonNameSort == false) {
            setExamNameSort(null);
            setBookNameSort(null);
            setSubjectNameSort(null);
        }
    }, [lessonNameSort])

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>Competitive Exam Lesson Master</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-file-circle-check"></i>Competitive Exam Lesson Master</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Competitive Exam Structure :</label>
                                                    <select class="form-select" aria-label="Default select example" name='competitiveExamNameMasterId' onChange={handleSyllabusChange} value={lessonData.competitiveExamNameMasterId}>
                                                        <option selected value={''} disabled>Select Competitive Exam Structure</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.examName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamNameMasterId && <p style={{ color: 'red' }}>{error.competitiveExamNameMasterId}</p>}
                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Book :</label>
                                                    <select class="form-select" aria-label="Default select example" name='competitiveExamBookMasterId' onChange={handleBookChange} value={lessonData.competitiveExamBookMasterId}>
                                                        <option selected value={''} disabled>Select Book</option>
                                                        {
                                                            bookList?.map((syllabus) => {
                                                                return <option value={syllabus.id}>{syllabus.bookName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.competitiveExamBookMasterId && <p style={{ color: 'red' }}>{error.competitiveExamBookMasterId}</p>}

                                                </div>

                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Subject :</label>
                                                    <select class="form-select" aria-label="Default select example" name='subjectMasterId' onChange={handleInputChange} value={lessonData.subjectMasterId}>
                                                        <option selected value={''} disabled>Select Subject</option>
                                                        {
                                                            subjectList?.map((syllabus) => {
                                                                return <option value={syllabus.subjectMasterDetails.id}>{syllabus.subjectMasterDetails.subjectName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {error.subjectMasterId && <p style={{ color: 'red' }}>{error.subjectMasterId}</p>}

                                                </div>


                                                {lessonData?.competitiveLessonName?.map((lesson, index) => (
                                                    <>
                                                        <div className="col-md-5">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Lesson Name :</label>
                                                            <input type="text" className="form-control" id={`competitiveLessonName${index}`} name='competitiveLessonName' onChange={(e) => handleInputChange(e, index)} value={lesson} />
                                                            {error.competitiveLessonName && <p style={{ color: 'red' }}>{error.competitiveLessonName}</p>}

                                                        </div>
                                                        {lessonData.competitiveLessonName.length > 1 && (
                                                            <div className="col-md-1 mt-4 mb-1" style={{ textAlign: 'right' }}>
                                                                <button className="btn btn-primary" type="button" style={{ marginTop: '14px' }} onClick={() => handleRemoveLesson(index)} ><i class="material-icons" style={{ fontSize: '20px' }} >delete</i></button>
                                                            </div>
                                                        )}
                                                    </>
                                                ))}
                                                {!editId && (
                                                    <div className="col-md-12 mt-4 mb-1">
                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ width: '233px' }} onClick={handleAddLesson}>+ Add Another Lesson Name</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        {!editId && <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={addLesson}>Save</button>
                                                        }                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setLessonList([]); setSubjectList([]); setEditId(''); setLessonData(initialFormState) }}>Reset</button>

                                                        {
                                                            editId && (<button className="btn btn-success approve_icon" type="button" onClick={updateLesson} disabled={!editId}>Update</button>)
                                                        }
                                                    </div>
                                                </div>

                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>
                                                                            Exam Name
                                                                            <SortIcon sortState={examNameSort} setSortState={setExamNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"competitiveExamNameMasterDetails.examName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Book Name
                                                                            <SortIcon sortState={bookNameSort} setSortState={setBookNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"competitiveExamBookMasterDetails.bookName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Subject Name
                                                                            <SortIcon sortState={subjectNameSort} setSortState={setSubjectNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"subjectMasterDetails.subjectName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Lesson Name
                                                                            <SortIcon sortState={lessonNameSort} setSortState={setLessonNameSort} setData={setLessonList} setCurrPage={setCurrPage} sortingPath={"competitiveLessonName"} />
                                                                        </th>
                                                                        <th scope="col">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((lesson, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{lesson?.competitiveExamNameMasterDetails?.examName}</td>
                                                                                        <td>{lesson?.competitiveExamBookMasterDetails?.bookName}</td>
                                                                                        <td>{lesson?.subjectMasterDetails?.subjectName}</td>
                                                                                        <td>{lesson.competitiveLessonName}</td>
                                                                                        <td>
                                                                                            <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => {
                                                                                                setLessonData({
                                                                                                    competitiveExamNameMasterId: lesson.competitiveExamNameMasterId,
                                                                                                    competitiveExamBookMasterId: lesson.competitiveExamBookMasterId,
                                                                                                    subjectMasterId: lesson.subjectMasterId,
                                                                                                    competitiveLessonName: [lesson.competitiveLessonName]
                                                                                                });
                                                                                                setEditId(lesson.id);
                                                                                                document.getElementById('scroll-up').scrollIntoView({ behavior: 'smooth' });
                                                                                            }}><i class="fa-light fa-pen-to-square"></i></button>
                                                                                            <button className="btn btn-outline-danger delete_icon" type="button" disabled={editId === lesson.id} onClick={() => deleteLesson(lesson.id)}> <i class="fa-light fa-trash-can"></i></button>
                                                                                        </td>
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Lesson Available</th>

                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>

                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={lessonList.length} />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default CompetitiveExamLessonMaster;